// *******************************************************************************
// Form handling
// *******************************************************************************

const getEmailError = (formElement) => {
  let emailMessage = '';
  if (formElement && formElement.querySelector('[type="email"]')) {
    emailMessage = formElement.querySelector('[type="email"]').getAttribute('data-fv-email-address___message');
  }
  return emailMessage;
};

const toggleLoaderClass = (elem, toggle) => {
  if (toggle === true) {
    elem.classList.add('is-loading');
    toggleBodyScrollLock(true);
  } else {
    setTimeout(() => {
      elem.classList.remove('is-loading');
      toggleBodyScrollLock(false);
    }, 1200);
  }
};

// eslint-disable-next-line require-await
const handleForm = async (form, formAction) => {
  const passwordField = document.getElementById('setPassword');
  const gCaptcha = document.querySelector('.g-captcha');
  const userEditFormSuccess = form.querySelector('.form-component__alert-success');
  const userEditFormError = form.querySelector('.form-component__alert-error');
  const newsletterFormError = form.querySelector('.newsletter-module__alert-error');
  const fomSection = document.querySelector('.sc-login-registration-form');
  const successSection = document.querySelector('.sc-reset-password');
  const newsletterSection = document.querySelector('.sc-newsletter-module .newsletter-module');
  const loading = document.querySelector('.site-loader');
  const showError = (err) => {
    if (userEditFormError) {
      userEditFormError.classList.remove('hide');
      userEditFormError.innerHTML = err;
    }
    if (newsletterFormError) {
      newsletterFormError.classList.remove('hide');
      newsletterFormError.innerHTML = err;
    }
  };

  const emailError = getEmailError(form);

  const fv = FormValidation.formValidation(form, {
    locale: 'sl_SI',
    localization: FormValidation.locales.sl_SI,
    fields: {
      email: {
        validators: {
          regexp: {
            regexp: '^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$',
            message: emailError,
          },
        },
      },
      newsletter_email_field: {
        validators: {
          regexp: {
            regexp: '^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$',
            message: emailError,
          },
        },
      },
      login_email: {
        validators: {
          regexp: {
            regexp: '^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$',
            message: emailError,
          },
        },
      },
      registration_email: {
        validators: {
          regexp: {
            regexp: '^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$',
            message: emailError,
          },
        },
      },
    },
    plugins: {
      message: new FormValidation.plugins.Message({
        container: (field, element) => element.closest('.mod-input,.checkbox,.calendar'),
      }),
      declarative: new FormValidation.plugins.Declarative({
        html5Input: true,
      }),
      trigger: new FormValidation.plugins.Trigger({
        event: 'submit',
      }),
      submitButton: new FormValidation.plugins.SubmitButton(),
    },
  }).on('core.element.validated', (e) => {
    // e.element presents the field element
    // e.valid indicates the field is valid or not

    // Get the field value
    const value = fv.getElementValue(e.field, e.element);
    const container = FormValidation.utils.closest(e.element, '.mod-input,.checkbox');
    FormValidation.utils.classSet(container, {
      'is-validation-failed': value === '' || !e.valid,
    });
  });

  if (gCaptcha) {
    const axiosAction = async (formData) => {
      const nonce = await getNonceForAction(formAction);
      grecaptcha.ready(() => {
        grecaptcha.execute(localData.captchaSiteKey, { action: formAction }).then((token) => {
          toggleLoaderClass(loading, true);
          const usersSubmitsActions = [
            'editUserData',
            'userResetPassword',
            'userAddAddress',
            'userEditAddress',
            'setHelpForm',
            'sendPasswordResetLink',
            'saveNewsletterSubscriptionFormMail',
          ];
          const formDataInput = new FormData();
          formDataInput.append('action', formAction);
          formDataInput.append('nonce', nonce);
          formDataInput.append('inputs', JSON.stringify(formData));
          formDataInput.append('lang', localData.lang);
          formDataInput.append('id', localData.id);
          formDataInput.append('token', token);
          axios
            .post(localData.apiURL, formDataInput, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then((response) => {
              if (usersSubmitsActions.includes(formAction)) {
                if (userEditFormSuccess) {
                  userEditFormSuccess.classList.remove('hide');
                }
                if (formAction !== 'editUserData' && formAction !== 'userEditAddress') {
                  form.reset();
                }
              }
              if (response.data.data.url) {
                window.location = response.data.data.url;
              } else {
                if (newsletterSection) {
                  newsletterSection.classList.add('show-thankyou');
                }
                if (fomSection) {
                  fomSection.hidden = true;
                }
                if (successSection) {
                  const formComponent = successSection.querySelector('.form-component');
                  if (formComponent) {
                    formComponent.classList.add('display-success');
                  }
                }
              }
              toggleLoaderClass(loading, false);
            })
            .catch((err) => {
              showError(err.response.data.data.msg);
              toggleLoaderClass(loading, false);
            });
        });
      });
    };

    fv.on('core.form.valid', () => {
      if (userEditFormSuccess) {
        userEditFormSuccess.classList.add('hide');
      }
      if (userEditFormError) {
        userEditFormError.classList.add('hide');
      }
      const formData = {};
      form.querySelectorAll('input, textarea').forEach((input) => {
        if (input.type === 'checkbox') {
          formData[input.name] = input.checked;
        } else if (input.type === 'radio') {
          if (input.checked) {
            formData[input.name] = input.dataset.type;
          }
        } else if (input.value.trim()) {
          formData[input.name] = input.value.trim();
        }
      });
      axiosAction(formData);
    });
  }

  if (passwordField) {
    const getValidationElem = (parent, selector) => parent.querySelector(selector);
    const passwordFieldParent = passwordField.closest('.mod-input');
    const [notEmptyMsg, capitalLettersMsg, lowerCaseMsg, digitMsg, minCharactersMsg, specialCharacter] = [
      '[data-fv-not-empty___message]',
      '[data-password-capital-letters]',
      '[data-password-lowercase]',
      '[data-password-digit]',
      '[data-password-min-characters]',
      '[data-password-special-character]',
    ].map((query) => getValidationElem(passwordFieldParent, query));
    const allValidationItems = passwordFieldParent.querySelectorAll('.mod-input__password-validation-item');
    const confirmPassValidationElem = document.getElementById('confirmResetPassword');

    const toggleValidationClass = (elem, toggle) => {
      passwordField.closest('.mod-input').classList.toggle('is-validation-failed', toggle);
      elem.classList.toggle('is-failed', toggle);
      elem.classList.toggle('is-passed', !toggle);
    };

    const strongPassword = () => ({
      // eslint-disable-next-line consistent-return
      validate(input) {
        const password = input.value;
        const lowercaseRegex = /[a-z]/;
        const uppercaseRegex = /[A-Z]/;
        const numberRegex = /\d/;
        const specialCharRegex = /[!@#$%^&*()_\-+=<>?]/;
        let isValid = true;

        if (password === '') {
          isValid = false;
          allValidationItems.forEach((elem) => {
            elem.classList.remove('is-failed');
            elem.classList.remove('is-passed');
          });
          passwordField.closest('.mod-input').classList.remove('is-validation-failed');
        }

        [
          {
            validator: !uppercaseRegex.test(password),
            element: capitalLettersMsg,
          },
          {
            validator: !lowercaseRegex.test(password),
            element: lowerCaseMsg,
          },
          {
            validator: !numberRegex.test(password),
            element: digitMsg,
          },
          {
            validator: !specialCharRegex.test(password),
            element: specialCharacter,
          },
          {
            validator: password.length < 8,
            element: minCharactersMsg,
          },
        ].forEach(({ validator, element }) => {
          if (validator) {
            isValid = false;
          }

          toggleValidationClass(element, validator);
        });

        if (isValid) {
          return {
            valid: true,
          };
        }
      },
    });

    const setPasswordValidators = {
      validators: {
        notEmpty: {
          message: notEmptyMsg.getAttribute('data-fv-not-empty___message'),
        },
        // checkPassword is name of new validator
        checkPassword: {
          message: notEmptyMsg.getAttribute('data-fv-not-empty___message'),
        },
      },
    };

    if (confirmPassValidationElem) {
      const confirmPassValidationMsg = confirmPassValidationElem.getAttribute('data-fv-identical___message');

      const confirmResetPasswordValidators = {
        validators: {
          identical: {
            compare() {
              return form.querySelector('[name="setPassword"]').value;
            },
            message: confirmPassValidationElem ? confirmPassValidationMsg : '',
          },
        },
      };

      fv.addField('confirmResetPassword', confirmResetPasswordValidators);
    }

    fv.addField('setPassword', setPasswordValidators);

    fv.registerValidator('checkPassword', strongPassword);

    // Validate password on password type
    const validateField = (setPassword) => {
      const field = fv.getFields(setPassword);
      if (field) {
        fv.validateField(setPassword);
      }
    };

    passwordField.addEventListener('input', () => {
      const fieldName = 'setPassword';
      validateField(fieldName);
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  [
    'login-form',
    'footer-newsletter-form',
    'registration-form',
    'forgot-password-form',
    'reset-password-form',
    'newsletter-form',
    'user-reset-password',
    'edit-data-form',
    'user-add-address',
    'user-edit-address',
    'user-help-form',
    'contact-form',
  ].forEach((id) => {
    const form = document.querySelector(`#${id}`);
    if (form !== null) {
      const formAction = form.querySelector('[data-action]').value;
      handleForm(form, formAction);
    }
  });
});

// eslint-disable-next-line func-names
(function () {
  let scriptsExecuted = false;
  document.addEventListener('click', (event) => {
    if (scriptsExecuted) {
      return;
    }
    if (event.target.tagName === 'INPUT') {
      document.querySelectorAll('.captcha-lazyload-scripts').forEach((script) => {
        if (script.type === 'text/plain') {
          script.type = 'text/javascript';
          document.head.appendChild(script);
          scriptsExecuted = true;
        }
      });
    }
  });
})();
